import { ShieldsLogo } from "@/components/brand/ShieldsLogo";

type ShieldsLoaderProps = {
  label?: string;
  fullScreen?: boolean;
};

export function ShieldsLoader({ label = "Preparing Shields", fullScreen = true }: ShieldsLoaderProps) {
  return (
    <div
      className={fullScreen ? "shields-loading-screen" : "shields-loading-inline"}
      role="status"
      aria-live="polite"
    >
      <div className="shields-loader-stage" aria-hidden>
        <span className="shields-loader-orbit"><i /></span>
        <span className="shields-loader-pulse"><ShieldsLogo showWordmark={false} /></span>
        <span className="shields-loader-light" />
      </div>
      <p>{label}<span aria-hidden>…</span></p>
    </div>
  );
}
